import type { FC } from 'react';

import LineThrough from 'shared/ui/LineThrough/LineThrough';
import { toNumberWithSpaces } from 'shared/lib/formatters';

import styles from './styles.module.scss';

interface ProductPrice {
  className?: string;
  price: number;
  list_price?: number;
  beforeDiscountPrice?: number;
  discount?: number;
}

const ProductPrice: FC<ProductPrice> = ({ className = '', price, beforeDiscountPrice, discount }) => {
  const containerClasses = [className, styles.productPrice].join(' ');

  return (
    <div className={containerClasses}>
      {/* Price display commented out
      <div className={styles.priceActual}>{toNumberWithSpaces(price)} ₽</div>
      */}
      {discount &&
        <div className={styles.LineThrough}>
          <LineThrough />
        </div>
      }

      {/* Old price display commented out
      {beforeDiscountPrice && <div className={styles.priceOld}>{toNumberWithSpaces(beforeDiscountPrice)} ₽</div>}
      */}
      {discount && (
        <>
          <div className={styles.priceDiscount} />
          <span className={styles.priceDiscountLabel}>- {discount}%</span>
        </>
      )}
    </div>
  );
};

export { ProductPrice };
